import Vue from 'vue';
import helpers from "./mixins/helpers";
import alert from '../components/alert/index'
import Fullscreen from '../components/fullscreen/component'
import axios from 'axios'

let stream =  Vue.extend({
    mixins: [helpers],
    data () {
        return {
            messages:{},
            pulls:pulls,
            currentPull:null,
            fixedMessage:[],
            forLectors:[],
            netMessage:false,
            status:streamStatus,
            chatAutoScroll:true,
            yotubeLink:yotubeLink,
            redirectUrl: redirectUrl,
            review:{
                trouble: null,
                rating: null,
                message:''
            },
            clients:0,
            client:{
                chat:{
                    reply:null
                }

            },
            isVasible: true,
            load: true,
            currentPage: null,
            pageCount: null,
            lastMessage: null,
            isNMO: isNMO,

            // Check Activity
            checkActivity: {
                theory: null,
                activity: null,
                intervalFunc: null,
                timeStart:  (+started_at),
                timeWaiting: (+controlDuration),
                timeLimit: (+controlInterval),
                countTickOpen: (+controlInterval),
                countTickClose: (+controlInterval) + (+controlDuration),
                timeCurrent: null,
                alertShow: false,
                sec: 0
            },

            fullscreen: false,
            btnSendReviewDisabled: false
        };
    },
    mounted () {
        // Check chat position bottom
        $("#chat-wrapper").on( 'scroll', () => {
            if ($("#chat-wrapper").scrollTop() >= $("#chat-wrapper")[0].scrollHeight - 501) {
                this.chatAutoScroll = true
            }
        });
        // -----

        let self = this;
        let socket = io.connect(location.protocol+'//'+location.hostname);
        socket
            .on('connect', () => {
                socket.emit('authenticate', {token: token});
                socket.emit('join', lection_id);
            })
            .on('authenticated', () => {
                console.log('Аутентификация успешна');
            })
            .on('unauthorized', data => {
                console.log('Аутентикация не удалась ошибка: ' + data.message);
            })
            .on('pull', data =>{
                setTimeout(function () {
                    self.currentPull = data.pull;
                    Vue.set(self.currentPull,'timer',0);
                    self.timer( self.currentPull.time);
                    $(".modal-5").modal('show');

                }, Math.floor(1 + Math.random() * 60) * 1000)
            })
            .on('chat', data => {
                Vue.set(this.messages, data.mid.toString(), data);
                this.scrollChat();
                console.log('chat');
            })
            .on('lectionStart', data => {

                var frame = $('iframe')[0];

                frame.src = frame.src;
                self.status = 1;

            })
            .on('toLector', data => {

                self.forLectors.push(data.mid);

            })
            .on('cancelLectorMsg', data => {

                self.forLectors = self.removeByValue(self.forLectors,data.mid);

            })
            .on('editLectorMsg', data => {

                self.messages[data.mid].message.text = data.text;

            })
            .on('removeMsg', data => {

                Vue.delete(self.messages,data.mid);
            })
            .on('fixMsg', data => {

                self.fixedMessage.push(data.mid);

            })
            .on('closeFixMsg', data => {
                self.fixedMessage = self.removeByValue(self.fixedMessage,data.mid);
            })
            .on('lectionTheoryEnd', data => {

                self.sendActivity();

                self.status = 2;
            })
            .on('lectionCompleted', data => {
                self.sendActivity();
                self.status = 3;

                if (self.redirectUrl) {
                    socket.close();
                    location.replace(self.redirectUrl);
                    return;
                }

                $(".modal-4").modal('show');

                setTimeout(() => {
                    socket.close();
                    location.replace('/');
                }, (20 * 60) * 1000);
            })
            .on('vote', data => {

                self.onVote(data);

            });

            this.loadHistory(1);
            this.loadFixedMessages();
            this.loadLectorMessages();
            this.getInfo();

            setInterval(() =>{
                this.sendActivity();
                this.getOnlineUsersCount();

            }, 60 * 1000);

            let $chatWrapper = $("#chat-wrapper");
            let $chat = $("#chat");
            $chatWrapper.scroll(function () {
                let $chatWrapperHeight = $chatWrapper.outerHeight();
                let $chatHeight = $chat.innerHeight();
                let scroll = ($chatHeight - $chatWrapperHeight) - $chatWrapper.scrollTop();

                self.chatAutoScroll = scroll <= 0 ? true : false;

            });
            $("#chat-wrapper")[0].addEventListener('scroll', this.handleScroll);

            $(function () {
                $('.modal-4 .next-step-1').click(function () {
                    $('.box-step-2').animate({right: "0px"}, 100);
                    $('.line-progress').animate({width: "50%"}, 600);
                    $('.point-1 .fa-check').css('transform','scale(1)');
                    $('.point-1 .fa-circle').css('transform','scale(0)');
                    $('.point-2').addClass('active');


                });
                $('.modal-4 .next-step-2').click(function () {
                    if (self.review.rating > 0) {
                    $('.box-step-3').animate({right: "0px"}, 100);
                    $('.line-progress').animate({width: "75%"}, 600);
                    $('.box-step-3 .line-progress').animate({width: "100%"}, 600);
                    $('.point-2 .fa-check').css('transform','scale(1)').css('display','block');
                    $('.point-2 .fa-circle').css('transform','scale(0)');
                    $('.point-3').addClass('active');
                    console.log(self.review.rating)
                    }
                });
                $('.modal-4 .next-step-3').click(function () {
                $('.line-progress').animate({width: "100%"}, 600);
                $('.point-3 .fa-check').css('transform','scale(1)');
                $('.point-3 .fa-circle').css('transform','scale(0)');
            });
            });

            // Check-activity
            let equivalent = 60;
            console.log(equivalent)
            if (this.isNMO) {
                this.checkActivity.timeCurrent = Math.round(new Date().getTime() / 1000);
                if (this.checkActivity.timeCurrent > this.checkActivity.timeStart) {
                    let countR;
                    if (this.checkActivity.timeCurrent - this.checkActivity.timeStart <  this.checkActivity.timeLimit * equivalent) {
                        countR  = (this.checkActivity.timeCurrent - this.checkActivity.timeStart) / ((this.checkActivity.timeLimit) * equivalent);
                    }
                    else {
                        countR  = (this.checkActivity.timeCurrent - this.checkActivity.timeStart) / ((this.checkActivity.timeLimit + this.checkActivity.timeWaiting) * equivalent);
                    }
                    let ceilCount = countR.toString().split('.')[0];
                    this.checkActivity.timeStart = (this.checkActivity.timeStart + (ceilCount * equivalent * (this.checkActivity.timeWaiting + this.checkActivity.timeLimit)));
                }
                this.interval = setInterval(async () => {
                    this.checkActivity.timeCurrent = Math.round(new Date().getTime() / 1000);
                    //console.log(this.checkActivity.timeCurrent + ' ' + this.checkActivity.sec);
                    if (this.checkActivity.timeCurrent > 0 && this.checkActivity.timeCurrent) {
                        this.checkActivity.sec++;
                        console.log(this.checkActivity.timeStart + (this.checkActivity.countTickOpen * equivalent));
                        if (this.checkActivity.timeCurrent > this.checkActivity.timeStart + (this.checkActivity.countTickOpen * equivalent)) {
                            this.checkActivity.countTickOpen = (this.checkActivity.timeLimit + this.checkActivity.timeWaiting + this.checkActivity.countTickOpen);
                            await this.theoryEnd();
                            if (this.checkActivity.theory) {
                                this.checkActivity.alertShow = true;
                            }
                            //$('.modal_check-activity').modal('show');
                        }
                        if (this.checkActivity.timeCurrent > this.checkActivity.timeStart + (this.checkActivity.countTickClose * equivalent)) {
                            this.checkActivity.countTickClose = (this.checkActivity.timeLimit + this.checkActivity.timeWaiting + this.checkActivity.countTickClose);
                            if (this.checkActivity.timeStart + (this.checkActivity.countTickClose * equivalent) > this.checkActivity.timeCurrent) {
                                this.checkActivity.alertShow = false
                                //$('.modal_check-activity').modal('hide');
                            }
                        }
                    }
                }, 1000 );
            }
    },
    updated () {
        this.scrollChat();
    },
    destroyed () {
        clearInterval(this.checkActivity.intervalFunc)
    },
    methods:{
        getOnlineUsersCount() {
            let self = this;
            let params = {
                id:lection_id
            };
            $.ajax({
                url:'/api/v1/stream/online-users-count',
                type: "GET",
                data:params,
                success:function (data){

                    self.clients = data.count;

                }
            });
        },
        getInfo(){
            let self = this;
            let params = {
                id:lection_id
            };
            $.ajax({
                url:'/api/v1/stream/statistic',
                type: "GET",
                data:params,
                success:function (data){

                    self.clients = data.users_online;

                }
            });
        },
        handleScroll() {
            let self = this;
            if ($("#chat-wrapper")[0].scrollTop === 0) {

                if (self.currentPage < self.pageCount) {

                    self.loadHistory(self.currentPage + 1);

                } else {

                    self.load = false;

                }
            }
        },
        sendMessage(){
            let self = this;
            let message = $("#message-area").val().trim();
            if(message.length > 0){
                $("#send-chat-message").attr('disabled','disabled');

                $.ajax({
                    url:'/lections/stream/send-message/'+lection_id,
                    type: "POST",
                    data: {
                        _csrf:self.getCsrf(),
                        message:message,
                        reply:self.client.chat.reply
                    },
                    beforeSend:function(){
                        self.client.chat.reply = null;
                        $("#message-area").val('');
                    },
                    complete:function (){
                        $("#send-chat-message").removeAttr('disabled');
                    }
                });
            }
            console.log('sendMessage')
        },
        replyMessage(mid){
            this.client.chat.reply = mid;
            $("#message-area").focus();
        },
        timer(time){
            let myCanvas = document.getElementById("timer"),
                context = myCanvas.getContext("2d"),
                timeLimit = time * 1000,
                timeStart = (new Date()).getTime(),
                canvasSize = 110,
                lineWidth = 4,
                self = this,
                radius = canvasSize / 2,
                drawY = radius,
                drawX = drawY;
            radius -= lineWidth / 2;
            myCanvas.width = canvasSize;
            myCanvas.height = canvasSize;

            function go() {
                context.beginPath();
                context.lineWidth = lineWidth;
                context.lineCap = "round";
                context.strokeStyle = "rgb(103, 198, 185)";
                let a = ((new Date()).getTime() - timeStart) / timeLimit;
                let timer;
                context.clearRect(0, 0, canvasSize, canvasSize);
                context.font = '35px bold Veredana, sans-serif';
                context.textAlign = 'center';
                context.fillText((time - a*time)|0, 54, 67);
                context.arc(drawX, drawY, radius, -Math.PI / 2 + 2 * Math.PI * a, -Math.PI / 2, !1);
                context.stroke();
                1 < a && (timeStart = (new Date()).getTime());
                if((time - a*time) <= 0){

                    $(".modal-5").modal('hide');

                    self.currentPull = null;

                } else {

                    if( self.currentPull !== null){

                        Vue.set(self.currentPull,'timer',time - a*time);

                    }

                   timer = window.setTimeout(go, 60);
                }

            }

            go();


        },
        sendPull(){
            let self = this;
            $("#send_vote").attr('disabled','disabled');
            $.ajax({
                url:'/lections/stream/send-vote/'+lection_id,
                type: "POST",
                data: {
                    pull_id:self.currentPull.id,
                    _csrf:self.getCsrf(),
                    vote:$("[name=pull_vote]:checked").val()
                },
                complete:function (){

                    $(".modal-5").modal('hide');

                    $("#send_vote").removeAttr('disabled');
                    self.currentPull = null;
                    }
                });
        },
        sendActivity(){
            $.ajax({
                url:'/lections/stream/send-activity/'+lection_id,
                type: "GET",
                error(){
                    sendEvent.errorStream(lection_id);
                }
            });
        },
        sendReview (){
            this.btnSendReviewDisabled = true
            let message = this.review.message;
            let self = this;
            $.ajax({
                url:'/lections/set-rating/'+lection_id,
                type: "POST",
                data: {
                    _csrf:self.getCsrf(),
                    vote:this.review.rating,
                    message:this.review.message,
                    trouble:this.review.trouble,
                    stream:true,
                },
                success:function(){
                    location.href = '/lections/'+lection_id;
                    sendEvent.action('lection value', lection_id, 'lection');
                    if (message !== null && message !== '') {
                        sendEvent.action('lection private comment', lection_id, 'lection');
                    }
                }
            });
        },
        scrollChat(){
            if(this.chatAutoScroll === true){
                $("#chat-wrapper").scrollTop($("#chat-wrapper")[0].scrollHeight);
            }
        },
        cancelReplySend() {
            this.client.chat.reply = null;
        },
        onVote(){
          return true;
        },

        // Chat
        loadHistory(page){
            let self = this;
            let params = {
                page:page,
                id:lection_id
            };

            self.lastMessage = Object.keys(self.messages)[0];
            self.load = true;

            $.ajax({
                url:'/api/v1/stream/chat',
                type: "GET",
                data:params,
                success:function (data){
                    let messages = data.items;

                    self.currentPage = data._meta.currentPage;
                    self.pageCount = data._meta.pageCount;

                    if(Object.keys(messages).length > 0){

                        for(var i in messages){
                            Vue.set(self.messages,messages[i].mid,messages[i]);
                        }

                        self.load = false;

                    } else {
                        self.load = false;

                    }

                }
            });
        },
        loadFixedMessages(){
            let self = this;

            let params = {
                id:lection_id
            };
            $.ajax({
                url:'/api/v1/stream/fixed-messages',
                type: "GET",
                data:params,
                success:function (data){
                    let messages = data.items;
                    if(Object.keys(messages).length > 0){
                        for(var i in messages){
                            Vue.set(self.messages,messages[i].mid,messages[i]);

                            self.fixedMessage.push(messages[i].mid);

                        }
                    }
                }
            });
        },
        loadLectorMessages(page){
            let self = this;
            page = page ? page:1;
            let params = {
                id:lection_id,
                page:page
            };
            $.ajax({
                url:'/api/v1/stream/lector-messages',
                type: "GET",
                data:params,
                success:function (data){
                    let messages = data.items;
                    if(Object.keys(messages).length > 0){
                        for(var i in messages){
                            Vue.set(self.messages,messages[i].mid,messages[i]);
                            self.forLectors.push(messages[i].mid);
                        }
                    }
                    if(data._meta.pageCount > page){
                        self.loadLectorMessages(page + 1);
                    }
                }
            });
        },
        isLectorMessage(mid) {
            return  this.in(mid, this.forLectors);
        },

        // Check Activity methods
        sendActivityUser() {
            let self = this;
            try {
                $.ajax({
                    url: '/api/v1/activity/confirmation',
                    dataType: "form-data",
                    method: 'POST',
                    data: {
                        lection_id: lection_id
                    },
                    success: function (data) {
                        // let self = this;
                        // self.checkActivity.activity = true;
                        console.log(data);
                        // console.log(self.checkActivity.activity)
                    },
                    fail() {
                        throw new Error('Ошибка получении данных');
                    }
                });

            } catch (e) {
                console.error(e);
            }
            this.checkActivity.activity = true;
            let alert = setTimeout( () => {
                this.checkActivity.activity = null;
            }, 4000 );
            this.checkActivity.alertShow = false
        },
        loadSound() {
            let sound = document.querySelector('audio');
            if (sound) {
                sound.load()
                sound.volume = 0;
                setTimeout(() => { sound.play(); }, 0);
            }

        },
        playSound() {
            const sound = document.querySelector('audio');
            if (sound) {
                sound.load();
                sound.volume = 1;
                setTimeout(() => {
                    sound.play();
                }, 100);
            }


        },
        async theoryEnd() {
            const res = await axios.get('/api/v1/activity/confirmation/active', {
                params: {
                    lection_id: lection_id
                }
            });
            console.log(res.data);
            this.checkActivity.theory = res.data
        },

        // FullScreen
        toggle () {
            this.$refs['fullscreen'].toggle()
        },
        fullscreenChange (fullscreen) {
            this.fullscreen = fullscreen
        },
    },
    created () {
        this.theoryEnd()
    },
    components: {
        alert,
        Fullscreen
    }

});
export default stream
if($("#stream").length > 0){
    let userStream = new stream().$mount('#stream');
    Offline.on('confirmed-up',function () {
        userStream.netMessage = false;
    });
    Offline.on('confirmed-down',function () {
        userStream.netMessage = true;
    });
}


